import GTM from './GTM';

export default GTM;
